import { useSelector } from 'react-redux'

type TimeZoneRootState = {
  userProfile?: {
    userProfile?: {
      timeZone?: string
    }
  }
}

export const useTimeZone = () => {
  const timeZone = useSelector(
    (state: TimeZoneRootState) =>
      state.userProfile?.userProfile?.timeZone || 'UTC'
  )

  return { loading: false, timeZone }
}
